import { Component, Input } from '@angular/core';

@Component({
  selector: 'ns-icon',
  template: require('./icon.component.html')
})

export class IconComponent {
  @Input() iconType;
}
